var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.hasSlotContent)?_c('div',_vm._b({ref:"markerContentRef",class:_setup.marker ? '' : 'hidden'},'div',_vm.$attrs,false),[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }